import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { caseComplianceQueryOptions } from "@/features/case-evaluation/api/queries/acitivities-query";
import { caseCollaboratorsQueryOptions, useCaseCollaboratorCanPostMutation } from "@/features/case-record/api/queries/case-collaborator-query";
import { formatDate } from "@/utils/format-date";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

export default function CaseComplianceHistoryModal({ caseId }: { caseId: string }) {
	const modal = useModal();

	const form = useForm({
		defaultValues: {},
	});

	const complianceQuery = useQuery(
		caseComplianceQueryOptions({
			id: caseId,
		}),
	);

	const compliances = complianceQuery.data?.data;
	console.log(compliances, "compliances");

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<table className="text-sm">
						<thead>
							<tr className="border-b-2 border-border/50">
								<th className="w-[220px] text-left text-foreground-dark p-3">Title</th>
								<th className=" text-left text-foreground-dark p-3">Date Ordered</th>
								<th className=" text-left text-foreground-dark p-3">Compliance Date</th>
								<th className=" text-left text-foreground-dark p-3">Status</th>
							</tr>
						</thead>
						<tbody>
							{compliances?.map((compliance, index) => (
								<tr key={index} className="border-b border-border/50 last:border-b-0">
									<td className="px-3 py-2">{compliance.activity ? compliance.activity : ""}</td>
									<td className="px-3 py-2">{compliance.ordered_at ? formatDate(compliance.ordered_at) : compliance.created_at}</td>
									<td className="px-3 py-2">{compliance.complied_at ? formatDate(compliance.complied_at) : ""}</td>
									{/* <td className="px-3 py-2">{compliance.complied_at ? compliance.complied_at : ""}</td> */}
									<td className="px-3 py-2">
										{compliance.complied_at ? (
											<div className="flex items-center space-x-2 text-green-600">
												<IconCheck className="w-4 h-4" />
												<span>Complied</span>
											</div>
										) : (
											<div className="flex items-center space-x-2 text-red-600">
												<IconX className="w-4 h-4" />
												<span>Pending</span>
											</div>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</form>
		</Form>
	);
}
